import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCards from "../Components/ProjectCards/ProjectCards";
import Particle from "../Components/Particles/Particle";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={6} className="project-card">
            <ProjectCards
              imgPath="https://user-images.githubusercontent.com/84279029/154837602-71703752-66e6-43dd-b65a-8cecba847cbf.png"
              title="Crypto Hunter"
              description="Crypto Hunter is a Crypto Currency Tracker web app created using ReactJS, ChartJS, MatrerialUI and CoinGecko API where
              user can get all the information regarding their favourite coin.It is compatable in mobile, web, and iOS platforms, Completely responsive design using Material UI."              link="https://cypto-hunter.herokuapp.com/"
            />
          </Col>
          <Col md={6} className="project-card">
            <ProjectCards
              imgPath="https://user-images.githubusercontent.com/84279029/154533116-8174d7b0-7ab0-4e92-9f7e-0afbfef53739.png"
              title="Inshorts Clone"
              description="This project is a replica of Inshorts News app using ReactJS, MaterialUI and news API where user can read news in
              less than 60 words, related to business, sports, bollywood and technology in India and around the world"
              link="https://github.com/Asif0401/inshorts-clone"
            />
          </Col>

          <Col md={6} className="project-card">
            <ProjectCards
              imgPath="https://user-images.githubusercontent.com/84279029/154533505-9978ae28-2b33-404d-ad0b-937bbc12a886.png"
              title="QuickCab"
              description="This is an user interface website created using NextJS, TailwindCSS where user can request a ride by choosing his pickup
              and dropoff locations.Also Included Mapbox API which provides Real time map, allows us to choose our pickup and dropoff points and
              gives time duration between our locations"              link="https://github.com/Asif0401/quickCab"
            />
          </Col>
          {/* <Col md={6} className="project-card">
            <ProjectCards
              imgPath="https://user-images.githubusercontent.com/91063960/139381648-76a0d2e5-9375-4f5a-8399-030888d8065e.png"
              title="Tesla Clone"
              description="In this small project you can play trailers of the Movies..,but I will be provide regualar updates with more features and functionalities because the entertainment industry is one of the largest online service businesses. The number of people seeking online entertainment is increasing rapidly. Increased leisure time and easier access to entertainment is driving the market forward."              link="https://github.com/sijeeshmiziha/netflix"
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}
export default Projects;
